import { Button, Grid, Typography } from "@material-ui/core";
import { IconArrowRight } from "@tabler/icons-react";
import { useHistory } from "react-router-dom";
import BLExportTable from "../../bl-exports/components/BLExportTable";

const BlsExportTableHome = () => {
  const history = useHistory();

  return (
    <Grid container>
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="body1">&nbsp;BL Export</Typography>
        <br />
      </Grid>
      <BLExportTable hideFilters hideFooter isHome />

      <Grid item xs={12} md={12} lg={12} style={{ textAlign: "right" }}>
        <Button
          onClick={() => history.push(`/bl-export`)}
          variant="outlined"
          color="primary"
          endIcon={<IconArrowRight />}
        >
          Ver más
        </Button>
      </Grid>
    </Grid>
  );
};

export default BlsExportTableHome;
